<template>
    <el-dialog title="访客申请" :visible.sync="showDialog">
        <el-row>
            <el-col :span="12">
                <el-card class="box-card">
                    <el-form label-width="120px" v-if="initData">
                        <el-form-item label="应聘者姓名">{{initData.resumeForm && initData.resumeForm.name}}</el-form-item>
                        <el-form-item label="手机">{{initData.resumeForm && initData.resumeForm.mobilePhone || '-'}}</el-form-item>
                        <el-form-item label="应聘职位">{{initData.positionForm && initData.positionForm.name}}</el-form-item>
                    </el-form>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-form :model="form" :rules="rules" v-if="baseData">
                    <el-form-item label="选择会议室" :label-width="formLabelWidth">
                        <el-select v-model="form.areaid" placeholder="请输入关键词">
                            <el-option
                                    v-for="item in baseData.MEETING_AREA_NAME"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="面试地点" :label-width="formLabelWidth">
                        <el-input v-model="form.interviewPlace" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="面试时间" :label-width="formLabelWidth">
                        <el-date-picker
                                v-model="form.interviewDate"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button @click="showDialog = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import axios from 'axios'
    export default {
        data () {
            return {
                formLabelWidth: '100px',
                initData: null,
                showDialog: false,
                form: {
                    resumePositionId: null,
                    id: null,
                    areaid: null,
                    interviewPlace: '',
                    interviewDate: ''
                },
                rules: {
                }
            }
        },
        methods: {
            baseData () {
                return this.$store.state.baseData.selectMap
            },
            submit () {
                axios.post('/resumePosition/interviewArrange/setGuestSign.api', Object.assign({}, this.form, {
                    interviewDate: this.getDateStr(this.form.interviewDate)
                }), {
                    'X-showMessage': true
                }).then(res => {
                    this.showDialog = false
                    this.$emit('reloadList', res)
                }).catch(() => {})
            },
            show (data, initData) {
                this.initData = initData
                this.form.resumePositionId = data.resumePositionId
                this.form.id = data.id
                this.form.interviewPlace = data.interviewPlace
                this.form.interviewDate = data.interviewDate
                this.showDialog = true
            },
            getDateStr (date) {
                if (typeof date === 'object') {
                    let M = date.getMonth() + 1,
                        d = date.getDate(),
                        h = date.getHours(),
                        m = date.getMinutes(),
                        dateStr = [date.getFullYear(), M < 10 ? '0' + M : M, d < 10 ? '0' + d : d].join('-'),
                        timeStr = [h < 10 ? '0' + h : h, m < 10 ? '0' + m : m].join(':')
                    return dateStr + ' ' + timeStr
                } else {
                    return date
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// vistorFlowDialog.vue?59f703eb